import * as OvationsApi from 'core/ovations-api';
import { range } from 'lodash';

import mockCertifiableAddress from './certifiableAddress';

export const mockCustomer: OvationsApi.Types.Customer = {
    id: '',
    email: 'test@test.com',
    firstName: 'testy',
    optInToFutureOffers: false,
    lastName: 'tester',
    phoneNumber: '1234567890',
    preferredEmail: 'test.alternate@test.com',
    preferredPhoneNumber: '5555555555',
    address: mockCertifiableAddress,
    preferredContactMethod: OvationsApi.Enums.NotificationChannelType.Email,
    preferredLanguage: '',
    isActive: true,
    isLegacyUser: false,
    legalName: '',
    alternateProfiles: [],
    customFields: {},
};

export const mockCustomerList: OvationsApi.Types.Customer[] = range(0, 7).map((i) => ({
    id: `_id__${i}`,
    email: `${i}test@test.com`,
    firstName: `testy${i}`,
    optInToFutureOffers: false,
    lastName: 'tester',
    phoneNumber: `123456789${i}`,
    preferredEmail: `${i}test.alternate@test.com`,
    preferredPhoneNumber: '5555555555',
    address: mockCertifiableAddress,
    preferredContactMethod: OvationsApi.Enums.NotificationChannelType.Email,
    preferredLanguage: '',
    isActive: true,
    isLegacyUser: false,
    hasSavedSsn: false,
    legalName: '',
    alternateProfiles: [],
    customFields: {},
}));

export default mockCustomer;
